<template>
    <div class="pt-3 p-md-3">
        <!-- cover card -->
        <div class="row">
            <div class="col">
                <div class="card rounded-lg position-relative">
                    <div class="card-img-top profile-cover cover">
                        <button @click="coverChange"
                                class="btn btn-sm btn-light shadow-none rounded-pill position-absolute cover-change-button">
                            Cover change
                        </button>
                        <img :src="user?.cover_picture?.full_url || urlGenerator('/images/default-cover.png')" class="" alt="cover image"/>
                    </div>
                    <!-- profile picture -->
                    <div class="avatar d-flex flex-column flex-md-row align-items-center gap-x-1"
                         style="pointer-events: none;">
                        <div class="rounded-circle profile-uploader position-relative" style="pointer-events: auto;">
                            <img :src="user?.profile_picture?.full_url || urlGenerator('/images/avatar-demo.jpg')" alt="pp">
                            <span @click="profilePictureChange"
                                  class="w-100 h-100 justify-content-center align-items-center profile-uploader--text">change</span>
                        </div>
                        <div class="text-white text-center text-md-left">
                            <h4 class="p-0 m-0">{{ user?.full_name }}</h4>
                        </div>
                    </div>
                    <div class="card-footer bg-transparent">
                        <div class="d-flex justify-content-center justify-content-md-end">
                            <a :href="urlGenerator('/profile/' + user.uuid)" class="btn btn-link py-0" :class="{ 'text-primary': location.pathname.split('/').includes('profile') }">
                                <app-icon class="mr-1" name="user"/>
                                Profile</a>
                            <!--                            <a href="#flowers" class="btn btn-link py-0">-->
                            <!--                                <app-icon class="mr-1" name="heart"/>-->
                            <!--                                Flowers</a>-->
                            <!--                            <a href="#friends" class="btn btn-link py-0">-->
                            <!--                                <app-icon class="mr-1" name="users"/>-->
                            <!--                                Friends</a>-->
                            <a :href="urlGenerator('/gallery/' + user.uuid)" class="btn btn-link py-0" :class="{ 'text-primary': location.pathname.split('/').includes('gallery') }">
                                <app-icon class="mr-1" name="image"/>
                                Gallery</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- content -->
        <div class="row mt-3">
            <div class="col-12 col-md-5 col-lg-4">
                <div class="card rounded-lg">
                    <div class="card-body p-4">
                        <h4>{{ $t('about') }}</h4>
                        <div>
                            <p v-if="user.profile?.about">{{ user.profile?.about }}</p>
                            <p class="text-muted" v-else>{{$t('nothing_to_show')}}</p>
                        </div>
                        <div class="d-flex flex-column gap-y-1">
                            <div v-if="user.profile?.gender" class="d-flex">
                                <div class="avatar-sm">
                                    <app-icon :size="20" class="mr-1 mr-md-2" name="shuffle"/>
                                </div>
                                <span class="bold">{{ $t(user.profile?.gender) }}</span>
                            </div>
                            <div v-if="user.profile?.address" class="d-flex">
                                <div class="avatar-sm">
                                    <app-icon :size="20" class="mr-1 mr-md-2" name="map-pin"/>
                                </div>
                                <span class="bold"> {{$t('live_at')}} {{ user.profile?.address }}</span>
                            </div>
                            <div v-if="user.email" class="d-flex">
                                <div class="avatar-sm">
                                    <app-icon :size="20" class="mr-1 mr-md-2" name="mail"/>
                                </div>
                                <a :href="'mailto:'+user.email">{{user.email}}</a>
                            </div>
                            <div v-if="user.contact" class="d-flex">
                                <div class="avatar-sm">
                                    <app-icon :size="20" class="mr-1 mr-md-2" name="phone"/>
                                </div>
                              <a :href="'tel:'+user.contact">{{user.contact}}</a>
                            </div>
                            <div v-if="user.date_of_birth" class="d-flex">
                                <div class="avatar-sm">
                                    <app-icon :size="20" class="mr-1 mr-md-2" name="gift"/>
                                </div>
                              <span>{{ formatDateToLocal(user.date_of_birth)}}</span>
                            </div>
                            <div v-for="(social, index) in visibleSocialLinks" class="d-flex align-items-center" :key="`social-item-${index}-${social.id}`">
                                <div class="avatar-sm">
                                    <app-icon class="mr-1 mr-md-2" :size="20" :name="social.icon"/>
                                </div>
                                <a :href="social.link" target="_blank" class="text-truncate">{{ social.link }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-7 col-lg-8 mt-3 mt-md-0 pl-3 pl-md-0">
                <div class="d-flex flex-column gap-y-1">
                    <new-post/>
                    <div class="d-flex flex-column gap-y-1">
                        <template>
                            <post-view v-for="(post, index) in posts" :post="post" :recent="post.recent" :key="`post-items-${post.id}`" @edit="edit" @del="del"/>
                        </template>
                        <app-pre-loader v-if="loading"/>
                        <app-empty-data-block v-if="!posts.length && !loading" :message="$t('empty_data_block_post')"/>
                    </div>
                </div>
                <edit-post-modal :id="selectedPostId" modal-id="post-edit-modal" v-if="wannaEdit" @close="closeModal" />
            </div>
        </div>
    </div>
</template>

<script>
import AppButton from '../../../../../core/components/buttons/AppButton.vue';
import NewPost from "../feed/NewPost";
import PostView from "../feed/PostView";
import {mapGetters, mapActions} from 'vuex'
import {axiosPost, urlGenerator} from "../../../../helpers/AxiosHelper";
import {COVER_PICTURE_CHANGE, PROFILE_PICTURE_CHANGE} from "../../../../config/ApiUrl";
import EditPostModal from "../feed/EditPostModal.vue";
import {formatDateToLocal} from "../../../../helpers/DateTimeHelper";

export default {
    components: {AppButton, NewPost, PostView, EditPostModal},
    data() {
        return {
            formatDateToLocal,
            location,
            urlGenerator,
            wannaEdit: false,
            selectedPostId: null
        };
    },
    methods: {
        ...mapActions({
            getLoginUser: 'getUser'
        }),
        profilePictureChange() {
            let input = document.createElement('input')
            input.type = 'file'
            input.accept = '.jpg, .png, .gif, .webp, .jpeg'
            input.click();
            input.addEventListener('change', (event) => {
                let avatar = event.target.files[0]
                let formData = new FormData();
                formData.append('profile_picture', avatar)
                axiosPost(PROFILE_PICTURE_CHANGE, formData).then(res => {
                    console.log(res)
                }).finally(() => {
                    this.getLoginUser()
                })
            })
        },
        coverChange() {
            let input = document.createElement('input')
            input.type = 'file'
            input.accept = '.jpg, .png, .gif, .webp, .jpeg'
            input.click();
            input.addEventListener('change', (event) => {
                let cover = event.target.files[0]
                let formData = new FormData();
                formData.append('cover_picture', cover)
                axiosPost(COVER_PICTURE_CHANGE, formData).then(res => {
                    console.log(res)
                }).finally(() => {
                    this.getLoginUser()
                })
            })
        },
        getImg(user) {
            return user.profile_picture?.full_url ? user.profile_picture.full_url : urlGenerator('/images/avatar-demo.jpg');
        },
        del(id){
            console.log(id)
            this.$store.dispatch('posts/delPost', id).then(res => {
                this.$toastr.s(res.data.message)
            }).finally(() => {})
        },
        edit(id) {
            this.selectedPostId = id
            this.openModal()
        },
        openModal() {
            this.wannaEdit = true
            $('#post-edit-modal').modal('show');
        },
        closeModal() {
            $('#post-edit-modal').modal('hide');
            this.wannaEdit = false
        }

    },
    computed: {
        ...mapGetters({
            loading: 'posts/loading',
            posts: 'posts/list',
            user: 'loggedInUser'
        }),
        visibleSocialLinks() {
          return this.user.social_links?.filter(item => item.link) || []
        }
    },
    mounted() {
        let _this = this
        window.addEventListener('scroll', _.debounce(function (e) {
            let scrollHeight = 944;
            let scrollBarPos = window.scrollY
            let totalHeight = window.document.body.clientHeight - scrollHeight
            if ((scrollBarPos + 20) > totalHeight) {
                if(!_this.loading) {
                    _this.$store.dispatch('posts/getAll', { loader: true, id: window.user.id })
                        .finally(() =>{})
                }
            }
        }, 500))
    },
    created() {
        this.$store.dispatch('posts/getAll', {id: window.user.id})
    }
};
</script>
<style scoped lang="scss">
.avatar {
    position: absolute;
    bottom: 52px;
    width: 100%;

    img {
        width: 72px;
        height: 72px;
    }
}

.rounded-lg {
    border-radius: 15px !important;
    overflow: hidden;
}

.profile-cover {
    object-fit: cover;
    img{
        min-height: 148px;
        max-height: 148px;
    }
}

.bold {
    font-weight: bold !important;
}

.profile-uploader {
    cursor: pointer;
    overflow: hidden;

    &--text {
        transition: .2s ease-in;
        display: flex;
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #00000080;
        z-index: 900;
        color: #fff;
    }

    &:hover {
        .profile-uploader--text {
            opacity: 1;
        }
    }
}

.cover {
    overflow: hidden;
    position: relative;
    img {
        width: 100%;
        object-fit: cover;
    }
    &-change-button {
        opacity: 0;
        top: 10px;
        left: 10px;
    }
    &:hover .cover-change-button {
        opacity: 1;
    }
}

.cover-change-button {
}

@media screen and (min-width: 768px) {
    .profile-cover {
        max-height: 200px;
        height: auto;
    }

    .avatar {
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: auto;

        img {
            width: 112px;
            height: 112px;
        }
    }
}
</style>